// extracted by mini-css-extract-plugin
export default {"root":"TRcAUr","title":"nsLogw"};